import { Component, Input, forwardRef, ViewEncapsulation } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

export interface SegOption {
    value: any;
    label: string;
}

// SESSION-admin-ptg-002 — shared `.seg`/`.seg-btn` segmented control.
// ControlValueAccessor so it binds via [(ngModel)] AND formControlName
// (reactive forms in sessions 003/004). Pure presentational; emits on select.
@Component({
    selector: 'app-segmented-control',
    templateUrl: './segmented-control.component.html',
    encapsulation: ViewEncapsulation.None,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => SegmentedControlComponent),
            multi: true,
        },
    ],
})
export class SegmentedControlComponent implements ControlValueAccessor {
    @Input() options: SegOption[] = [];
    @Input() full = true;

    value: any;
    disabled = false;

    private onChange: (v: any) => void = () => {};
    private onTouched: () => void = () => {};

    writeValue(v: any): void {
        this.value = v;
    }
    registerOnChange(fn: (v: any) => void): void {
        this.onChange = fn;
    }
    registerOnTouched(fn: () => void): void {
        this.onTouched = fn;
    }
    setDisabledState(isDisabled: boolean): void {
        this.disabled = isDisabled;
    }

    select(opt: SegOption): void {
        if (this.disabled || opt.value === this.value) {
            return;
        }
        this.value = opt.value;
        this.onChange(this.value);
        this.onTouched();
    }
}
